import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/251c799b-17fb-47fb-b460-53096495f5cb";
export const REGISTER_URL = "https://a.ntrk2.com/c97aa2a1-cc95-44df-940c-2dd099ecc531";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://hitpk.loadprkw2a.com/download?openExternalBrowser=1&id=wv1p4r8emi40l14";

export * from "./codes";
export * from "./context";
